import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from '@mui/material';
export type ApprovalSlotState = 'approved' | 'pending' | 'denied';
export const ApprovalDots = t0 => {
  const $ = _c(4);
  const {
    slots
  } = t0;
  let t1;
  if ($[0] !== slots) {
    t1 = slots.map(_temp);
    $[0] = slots;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Stack direction="row" gap="4px" alignItems="center">{t1}</Stack>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const ApprovalDot = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <Box sx={{
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: color
    }} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(state, i) {
  const color = state === "approved" ? "var(--mui-palette-success-main)" : state === "denied" ? "var(--mui-palette-error-main)" : "var(--mui-palette-divider)";
  return <ApprovalDot key={i} color={color} />;
}